module.exports = __webpack_public_path__ + "fonts/icofont.22304f67.ttf";